module.exports = __webpack_public_path__ + "static/media/set-farbe.f769557c.png";